import { doAjax, initStitchesBackgroundColorListeners, initColorSelect, fakeSelected, changeStitchBackgroundColor } from './helper'
import { getColorByCode } from './color-languages'


const initComponentsSeatsCustomizing = () => {
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
	const thirdSeatRow = document.querySelector("input[name=thirdseatrow]").value;
	initColorSelect()
	loadBasicColorSeatLayers(frontSeatModel,backSeatModel)

	let frontseatComponents = ['headrestSide','headrestFront','headrestRear','headBoxSide','headBoxFront','headrestFrontSline','headrestStitching','shoulderArch',
	'shoulderBolsters','thighPad','bolstersOutside','seatCenterPanel','seatSideBolstersInside','circumferentialBand','circumferentialBand01','circumferentialBand02','circumferentialBand03','backrestTop',
	'seatSideBolstersOutside','seatSideBolstersOutside02','seatSideBolstersOutside03','seatSideBolstersOutside04','seatSideBolstersOutside05','contrastStitchingSide','contrastStitchingCenter','contrastStitchingHoneycombQuilting',
	'contrastStitchingDiamondQuilting','embossing','biese','headrestFront2','seatCenterPanel2','seatSportStripe', 'backrestCover','seatCover2']

	frontseatComponents.forEach(component => {
		initRedPointLogic('frontSeat', component)
		checkCustomizedComponentsOnLoading('frontSeat', component)
	});

	let backseatComponents = ['headrestFront','headrestSide','headrestRear','headBoxSide','headBoxFront','headrestFrontSline','headrestSideRear','headrestStitching','centerHeadrestFront',
	'centerHeadrestSide','centerHeadrestRear','shoulderArch','thighPad','bolstersOutside','bolstersCenter',
	'seatCenterPanel','seatSideBolstersInside','circumferentialBand','circumferentialBand2','circumferentialBand01','circumferentialBand02','circumferentialBand03','seatSidePadding','backrestTop',
	'seatSideBolstersOutside','seatSideBolstersOutside2','seatSideBolstersOutside02b','seatSideBolstersOutside04','rearCenterArmrest','seatCenterSectionAbove',
	'seatCenterSectionBottom','contrastStitchingCenterHeadrest','contrastStitchingSide','contrastStitchingCenter','contrastStitchingHoneycombQuilting',
	'contrastStitchingDiamondQuilting','embossing','biese','headrestFront2','seatCenterThighPad','seatCenterShoulderArch',
	'seatCenterBolster','seatCenterBolsterBottom','seatCenterMiddle','seatSideBolstersBottom','seatMiddle',
	'seatCenterPanel2','seatSportStripe']

	backseatComponents.forEach(component => {
		initRedPointLogic('backSeat', component)
		checkCustomizedComponentsOnLoading('backSeat', component)
	});

	checkCustomizedComponentsOnLoading('backSeat', 'upholsteryBarOutside') //special case
	if((frontSeatModel != 'Q2J_AU53X') && (frontSeatModel != 'Q1D_AU53X')) {
		if((frontSeatModel == 'Q4Q_AU53X') || (frontSeatModel == 'Q4Q_RS_AU53X')) {
			initStitchesBackgroundColorListeners(getFrontSeatComponentDotId('seatCenterPanel2'), getFrontSeatComponentDotId('contrastStitchingCenter'))
			initStitchesBackgroundColorListeners(getBackSeatComponentDotId('seatCenterPanel2'), getBackSeatComponentDotId('contrastStitchingCenter'))
		}
		else {
			initStitchesBackgroundColorListeners(getFrontSeatComponentDotId('seatCenterPanel'), getFrontSeatComponentDotId('contrastStitchingHoneycombQuilting'))
			initStitchesBackgroundColorListeners(getBackSeatComponentDotId('seatCenterPanel'), getBackSeatComponentDotId('contrastStitchingHoneycombQuilting'))
			initStitchesBackgroundColorListeners(getFrontSeatComponentDotId('seatCenterPanel'), getFrontSeatComponentDotId('contrastStitchingDiamondQuilting'))
			initStitchesBackgroundColorListeners(getBackSeatComponentDotId('seatCenterPanel'), getBackSeatComponentDotId('contrastStitchingDiamondQuilting'))
			initStitchesBackgroundColorListeners(getFrontSeatComponentDotId('seatCenterPanel'), getFrontSeatComponentDotId('contrastStitchingCenter'))
			initStitchesBackgroundColorListeners(getBackSeatComponentDotId('seatCenterPanel'), getBackSeatComponentDotId('contrastStitchingCenter'))
		}
	}

	if(thirdSeatRow) {
		const secondRowItem = document.querySelector("#backseat");
		const secondRowHide = document.querySelector("#hideSecondRow");
		const secondRowShow = document.querySelector("#showSecondRow");
		secondRowHide.addEventListener("click", (e) => {
			secondRowItem.classList.add("vis-hidden")
			secondRowHide.classList.add("hidden");
			secondRowShow.classList.remove("hidden");
		});
		secondRowShow.addEventListener("click", (e) => {
			secondRowItem.classList.remove("vis-hidden")
			secondRowHide.classList.remove("hidden");
			secondRowShow.classList.add("hidden");
		});
	}
	
}

const initRedPointLogic = (seatType, component) => {
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const componentMatchingDotId = seatType == "frontSeat" ? getFrontSeatComponentDotId(component) : getBackSeatComponentDotId(component)
	const componentTiles = document.querySelectorAll('#' + componentMatchingDotId + ' .color')
	const mainSeatColorCode = document.querySelector('#picked-color td[color-code]')?.getAttribute('color-code')
	componentTiles?.forEach(element => {
		element.addEventListener("click", function (e) {
			e.preventDefault()
			const componentColorCode = element.querySelector('input')?.value
			const frontSeatComponentColorCode = document.querySelector('#seat-components #' + component + ' td[name=frontseat]')?.getAttribute('color-code')
			const backSeatComponentColorCode = document.querySelector('#seat-components #' + component + '  td[name=backseat]')?.getAttribute('color-code')
			
			// Special case pim/sec circumferentialBandColorCode/seatSideBolstersOutsideColorCode only a8
			if(document.querySelector("input[name=modelcategory]").value == 'a8') {
				const circumferentialBandColorCode = document.querySelector('#seat-components #circumferentialBand td[name=frontseat]')?.getAttribute('color-code')
				const seatSideBolstersOutsideColorCode = document.querySelector('#seat-components #seatSideBolstersOutside td[name=frontseat]')?.getAttribute('color-code')
				const backSeatcircumferentialBandColorCode = document.querySelector('#seat-components #circumferentialBand td[name=backseat]')?.getAttribute('color-code')
				const backSeatseatSideBolstersOutsideColorCode = document.querySelector('#seat-components #seatSideBolstersOutside td[name=backseat]')?.getAttribute('color-code')
				if((component == "circumferentialBand" || component == "seatSideBolstersOutside") && seatType == 'frontSeat') {
					if (circumferentialBandColorCode == mainSeatColorCode && seatSideBolstersOutsideColorCode == mainSeatColorCode) {
						if (component == "circumferentialBand") {
							setImageOnSeat("frontSeat", 'seatSideBolstersOutside', componentColorCode);
						} else {
							setImageOnSeat("frontSeat", 'circumferentialBand', componentColorCode);
						}
						if (circumferentialBandColorCode == backSeatcircumferentialBandColorCode) {
							setImageOnSeat('backSeat', 'circumferentialBand', componentColorCode)
							fakeSelected('backseat #circumferentialBand', componentColorCode)
						}
						if (seatSideBolstersOutsideColorCode == backSeatseatSideBolstersOutsideColorCode) {
							setImageOnSeat('backSeat', 'seatSideBolstersOutside', componentColorCode)
							fakeSelected('backseat #seatSideBolstersOutside', componentColorCode)
						}			
					}
				}
			}

			// hide headrestSide e-tron gt
			if(document.querySelector("input[name=modelcategory]").value == 'e-tron_gt') {// hide headrestSide e-tron gt
				if (seatType == 'backSeat') {// hide headrestSide e-tron gt
					if (component == "headrestRear") {// hide headrestSide e-tron gt
						setImageOnSeat("backSeat", 'headrestSide', componentColorCode);// hide headrestSide e-tron gt
						fakeSelected('backSeat #headrestSide', componentColorCode)// hide headrestSide e-tron gt
					}// hide headrestSide e-tron gt
					if (component == "centerHeadrestRear") {// hide headrestSide e-tron gt
						setImageOnSeat("backSeat", 'centerHeadrestSide', componentColorCode);// hide headrestSide e-tron gt
						fakeSelected('backSeat #centerHeadrestSide', componentColorCode)// hide headrestSide e-tron gt
					}// hide headrestSide e-tron gt
				}// hide headrestSide e-tron gt
			}// hide headrestSide e-tron gt
		 	
			//condition to modify both seats
			if (seatType == 'frontSeat' && frontSeatComponentColorCode == backSeatComponentColorCode) {
				setImageOnSeat(seatType, component, componentColorCode)
				setImageOnSeat("backSeat", component, componentColorCode)
				fakeSelected('backseat #' + getBackSeatComponentDotId(component), componentColorCode)

				//Special case
				if (component == "seatCenterPanel") {
					setImageOnSeat("backSeat", 'upholsteryBarOutside', componentColorCode);
					changeStitchBackgroundColor('backseat #' + getBackSeatComponentDotId('contrastStitchingHoneycombQuilting'), componentColorCode)
					changeStitchBackgroundColor('backseat #' + getBackSeatComponentDotId('contrastStitchingDiamondQuilting'), componentColorCode)
					changeStitchBackgroundColor('backseat #' + getBackSeatComponentDotId('contrastStitchingCenter'), componentColorCode)
				}
				/* special case combine 'bolstersOutsidePressedColor' with 'seatCenterPanel2PressedColor' OR 'seatCenterPanelPressedColor' START */
				if (component == "seatCenterPanel" || component == "seatCenterPanel2") {
					const backSeatBolstersOutsideColorCode = document.querySelector('#seat-components #bolstersOutside td[name=backseat]')?.getAttribute('color-code')
					if (backSeatComponentColorCode == backSeatBolstersOutsideColorCode) {
						setImageOnSeat("backSeat", 'bolstersOutside', componentColorCode);
						fakeSelected('backseat #back-bolstersOutside', componentColorCode)
					}
				}
				/* special case combine 'bolstersOutsidePressedColor' with 'seatCenterPanel2PressedColor' OR 'seatCenterPanelPressedColor' END */
				//Special case
				const backSeatCenterHeadrestFrontColorCode = document.querySelector('#seat-components #centerHeadrestFront td[name=backseat]')?.getAttribute('color-code')
				if (component == "headrestFront" && frontSeatComponentColorCode == backSeatCenterHeadrestFrontColorCode) {
					setImageOnSeat("backSeat", 'centerHeadrestFront', componentColorCode);
					fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestFront'), componentColorCode)
				}
				//Special case
				const backSeatCenterHeadrestSideColorCode = document.querySelector('#seat-components #centerHeadrestSide td[name=backseat]')?.getAttribute('color-code')
				if (component == "headrestSide" && frontSeatComponentColorCode == backSeatCenterHeadrestSideColorCode) {
					setImageOnSeat("backSeat", 'centerHeadrestSide', componentColorCode);
					fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestSide'), componentColorCode)
				}
				//Special case
				const backSeatcontrastStitchingCenterHeadrestColorCode = document.querySelector('#seat-components #contrastStitchingCenterHeadrest td[name=backseat]')?.getAttribute('color-code')
				if (component == "contrastStitchingSide" && frontSeatComponentColorCode == backSeatcontrastStitchingCenterHeadrestColorCode
					&& isColorOfferedOnBackSeatComponent('contrastStitchingCenterHeadrest', componentColorCode)) {
					setImageOnSeat("backSeat", 'contrastStitchingCenterHeadrest', componentColorCode);
					fakeSelected('backseat #' + getBackSeatComponentDotId('contrastStitchingCenterHeadrest'), componentColorCode)
				}
				//Special case
				if (frontSeatModel == 'Q4Q_AU41X' || frontSeatModel == 'Q4Q_AU41X_PERF' ||frontSeatModel == 'Q4Q_AU513') {
					const backSeatCenterHeadrestRearColorCode = document.querySelector('#seat-components #centerHeadrestRear td[name=backseat]')?.getAttribute('color-code')
					if (component == "headrestRear" && frontSeatComponentColorCode == backSeatCenterHeadrestRearColorCode) {
						setImageOnSeat("backSeat", 'centerHeadrestRear', componentColorCode);
						fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestRear'), componentColorCode)
					}
				}
				//Special case
				if (frontSeatModel == 'Q1J') {
					const backSeatCenterHeadrestRearColorCode = document.querySelector('#seat-components #centerHeadrestRear td[name=backseat]')?.getAttribute('color-code')
					if (component == "headrestSide") {
						if (frontSeatComponentColorCode == backSeatCenterHeadrestSideColorCode) {
							setImageOnSeat("backSeat", 'centerHeadrestSide', componentColorCode);
							fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestSide'), componentColorCode);
							setImageOnSeat("backSeat", 'headrestRear', componentColorCode); 
							fakeSelected('backseat #' + getBackSeatComponentDotId('headrestRear'), componentColorCode);
							setImageOnSeat("backSeat", 'centerHeadrestRear', componentColorCode);
					fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestRear'), componentColorCode);
						} else {
							setImageOnSeat("backSeat", 'headrestRear', componentColorCode);
					fakeSelected('backseat #' + getBackSeatComponentDotId('headrestRear'), componentColorCode);
						}
					}
					
				}

				//Special case Q4Q_AU41X seatSideBolstersOutside
				if ((frontSeatModel == 'Q4Q_AU41X' || frontSeatModel == 'Q4Q_AU41X_PERF' ||frontSeatModel == 'Q4Q_AU401' || frontSeatModel == 'Q4Q_AU401_RS' || frontSeatModel == 'Q4Q_AU592' || frontSeatModel == 'Q4Q_AU513')   && seatType == 'frontSeat') {
					const frontSeatBasis = document.querySelector('#seat-components #picked-color td[color-code]')?.getAttribute('color-code');
					const frontSeatSideBolstersOutsideColorCode = element.querySelector('input')?.value
					const backseatCenterSectionAbove = document.querySelector('#seat-components #seatCenterSectionAbove td[name=backseat]')?.getAttribute('color-code')
					const backcenterHeadrestRear = document.querySelector('#seat-components #centerHeadrestRear td[name=backseat]')?.getAttribute('color-code')
					const backseatSidePadding = document.querySelector('#seat-components #seatSidePadding td[name=backseat]')?.getAttribute('color-code')
					
					if(component == "seatSideBolstersOutside") {
						setImageOnSeat("frontSeat", 'seatSideBolstersOutside02', frontSeatSideBolstersOutsideColorCode);
						fakeSelected('seat-single #' + getFrontSeatComponentDotId('seatSideBolstersOutside02'), frontSeatSideBolstersOutsideColorCode)
						setImageOnSeat("frontSeat", 'seatSideBolstersOutside03', frontSeatSideBolstersOutsideColorCode);
						fakeSelected('seat-single #' + getFrontSeatComponentDotId('seatSideBolstersOutside03'), frontSeatSideBolstersOutsideColorCode)
						if((frontSeatModel == 'Q4Q_AU401' || frontSeatModel == 'Q4Q_AU401_RS' || frontSeatModel == 'Q4Q_AU592') && frontSeatComponentColorCode == frontSeatBasis) {
							if( frontSeatComponentColorCode == backseatCenterSectionAbove 
								&& frontSeatComponentColorCode == backcenterHeadrestRear 
								&& frontSeatComponentColorCode == backseatSidePadding ) {
								setImageOnSeat("backSeat", 'seatCenterSectionAbove', frontSeatSideBolstersOutsideColorCode);
								fakeSelected('backseat #' + getBackSeatComponentDotId('seatCenterSectionAbove'), frontSeatSideBolstersOutsideColorCode)
								setImageOnSeat("backSeat", 'centerHeadrestRear', frontSeatSideBolstersOutsideColorCode);
								fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestRear'), frontSeatSideBolstersOutsideColorCode)
								setImageOnSeat("backSeat", 'seatSidePadding', frontSeatSideBolstersOutsideColorCode);
								fakeSelected('backseat #' + getBackSeatComponentDotId('seatSidePadding'), frontSeatSideBolstersOutsideColorCode)
								setImageOnSeat("backSeat", 'headrestRear', frontSeatSideBolstersOutsideColorCode);
								fakeSelected('backseat #' + getBackSeatComponentDotId('headrestRear'), frontSeatSideBolstersOutsideColorCode)
								
							}
						}
					}
				}

			} else {
		
				/* special case combine 'bolstersOutsidePressedColor' with 'seatCenterPanel2PressedColor' OR 'seatCenterPanelPressedColor' START */
				if ((component == "seatCenterPanel" || component == "seatCenterPanel2") && seatType == 'backSeat') {
					const backSeatBolstersOutsideColorCode = document.querySelector('#seat-components #bolstersOutside td[name=backseat]')?.getAttribute('color-code')
					if (backSeatComponentColorCode == backSeatBolstersOutsideColorCode) {
						setImageOnSeat("backSeat", 'bolstersOutside', componentColorCode);
						fakeSelected('backseat #back-bolstersOutside', componentColorCode)
					}
				}
				/* special case combine 'bolstersOutsidePressedColor' with 'seatCenterPanel2PressedColor' OR 'seatCenterPanelPressedColor' END */
				
				//Special case
				const backSeatCenterHeadrestFrontColorCode = document.querySelector('#seat-components #centerHeadrestFront td[name=backseat]')?.getAttribute('color-code')
				if (component == "headrestFront" && seatType == 'backSeat' && backSeatComponentColorCode == backSeatCenterHeadrestFrontColorCode) {
					setImageOnSeat("backSeat", 'centerHeadrestFront', componentColorCode);
					fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestFront'), componentColorCode)
				}

				//Special case
				const backSeatCenterHeadrestSideColorCode = document.querySelector('#seat-components #centerHeadrestSide td[name=backseat]')?.getAttribute('color-code')
				if (component == "headrestSide" && seatType == 'backSeat' && backSeatComponentColorCode == backSeatCenterHeadrestSideColorCode) {
					setImageOnSeat("backSeat", 'centerHeadrestSide', componentColorCode);
					fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestSide'), componentColorCode)
				}

				//Special case
				const backSeatcontrastStitchingCenterHeadrestColorCode = document.querySelector('#seat-components #contrastStitchingCenterHeadrest td[name=backseat]')?.getAttribute('color-code')
				if (component == "contrastStitchingSide" && frontSeatComponentColorCode == backSeatcontrastStitchingCenterHeadrestColorCode
					&& isColorOfferedOnBackSeatComponent('contrastStitchingCenterHeadrest', componentColorCode)) {
					setImageOnSeat("backSeat", 'contrastStitchingCenterHeadrest', componentColorCode);
					fakeSelected('backseat #' + getBackSeatComponentDotId('contrastStitchingCenterHeadrest'), componentColorCode)
				}

				//Special case
				if (frontSeatModel == 'Q1J'  && seatType == 'backSeat') {
					const backSeatCenterHeadrestRearColorCode = document.querySelector('#seat-components #centerHeadrestRear td[name=backseat]')?.getAttribute('color-code')
					if (component == "headrestRear" && backSeatComponentColorCode == backSeatCenterHeadrestRearColorCode) {
						setImageOnSeat("backSeat", 'centerHeadrestRear', componentColorCode);
						fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestRear'), componentColorCode)
						setImageOnSeat("backSeat", 'headrestSide', componentColorCode);	// hide headrestSide e-tron gt
						fakeSelected('backseat #' + getBackSeatComponentDotId('headrestSide'), componentColorCode) // hide headrestSide e-tron gt
						setImageOnSeat("backSeat", 'centerHeadrestSide', componentColorCode);	// hide headrestSide e-tron gt
						fakeSelected('backseat #' + getBackSeatComponentDotId('centerHeadrestSide'), componentColorCode) // hide headrestSide e-tron gt
					} 
				}
				//Special case Q4Q_AU41X seatSideBolstersOutside
				if ((frontSeatModel == 'Q4Q_AU41X' || frontSeatModel == 'Q4Q_AU41X_PERF' ||frontSeatModel == 'Q4Q_AU401' || frontSeatModel == 'Q4Q_AU401_RS' || frontSeatModel == 'Q4Q_AU592' || frontSeatModel == 'Q4Q_AU513')   && seatType == 'frontSeat') {
					const frontSeatSideBolstersOutsideColorCode = element.querySelector('input')?.value
					if(component == "seatSideBolstersOutside") {
						setImageOnSeat("frontSeat", 'seatSideBolstersOutside02', frontSeatSideBolstersOutsideColorCode);
						fakeSelected('seat-single #' + getFrontSeatComponentDotId('seatSideBolstersOutside02'), frontSeatSideBolstersOutsideColorCode)
						setImageOnSeat("frontSeat", 'seatSideBolstersOutside03', frontSeatSideBolstersOutsideColorCode);
						fakeSelected('seat-single #' + getFrontSeatComponentDotId('seatSideBolstersOutside03'), frontSeatSideBolstersOutsideColorCode)
					}
				}
				

				// Special case pim/sec circumferentialBandColorCode/seatSideBolstersOutsideColorCode only a8
				if(document.querySelector("input[name=modelcategory]").value == 'a8') { 
					const backSeatcircumferentialBandColorCode = document.querySelector('#seat-components #circumferentialBand td[name=backseat]')?.getAttribute('color-code')
					const backSeatseatSideBolstersOutsideColorCode = document.querySelector('#seat-components #seatSideBolstersOutside td[name=backseat]')?.getAttribute('color-code')
					if(component == "circumferentialBand" || component == "seatSideBolstersOutside") {
						if (backSeatcircumferentialBandColorCode == mainSeatColorCode && backSeatseatSideBolstersOutsideColorCode == mainSeatColorCode) {
							if (component == "circumferentialBand") {
								setImageOnSeat("backSeat", 'seatSideBolstersOutside', componentColorCode);
							} else {
								setImageOnSeat("backSeat", 'circumferentialBand', componentColorCode);
							}
							fakeSelected('backseat #' + getBackSeatComponentDotId(component), componentColorCode)
						}
					}
				}
	
				setImageOnSeat(seatType, component, componentColorCode)
				if (component == "seatCenterPanel" && seatType == 'backSeat') {
					setImageOnSeat("backSeat", 'upholsteryBarOutside', componentColorCode);
				}
			}

			//Special case Q4Q_AU41X circumferentialBand01/02/03
			if ((frontSeatModel == 'Q4Q_AU41X' || frontSeatModel == 'Q4Q_AU41X_PERF' ||frontSeatModel == 'Q4Q_AU401' || frontSeatModel == 'Q4Q_AU401_RS' || frontSeatModel == 'Q4Q_AU592' || frontSeatModel == 'Q4Q_AU513') && seatType == 'frontSeat') {
				
				const frontSeatBasis = document.querySelector('#seat-components #picked-color td[color-code]')?.getAttribute('color-code');
				const frontcircumferentialBand = element.querySelector('input')?.value
				const frontcircumferentialBand01 = document.querySelector('#seat-components #circumferentialBand01 td[name=frontseat]')?.getAttribute('color-code')
				const backcircumferentialBand01 = document.querySelector('#seat-components #circumferentialBand01 td[name=backseat]')?.getAttribute('color-code')
				const frontcircumferentialBand02 = document.querySelector('#seat-components #circumferentialBand02 td[name=frontseat]')?.getAttribute('color-code')
				const backcircumferentialBand02 = document.querySelector('#seat-components #circumferentialBand02 td[name=backseat]')?.getAttribute('color-code')
				const frontcircumferentialBand03 = document.querySelector('#seat-components #circumferentialBand03 td[name=frontseat]')?.getAttribute('color-code')
				const backcircumferentialBand03 = document.querySelector('#seat-components #circumferentialBand03 td[name=backseat]')?.getAttribute('color-code')

				// Sammeln aller zu prüfenden Variablen in einem Array
				const bands = [
					{ seatType: 'frontSeat', component: 'circumferentialBand01', colorCode: frontcircumferentialBand01 },
					{ seatType: 'backSeat',  component: 'circumferentialBand01', colorCode: backcircumferentialBand01 },
					{ seatType: 'frontSeat', component: 'circumferentialBand02', colorCode: frontcircumferentialBand02 },
					{ seatType: 'backSeat',  component: 'circumferentialBand02', colorCode: backcircumferentialBand02 },
					{ seatType: 'frontSeat', component: 'circumferentialBand03', colorCode: frontcircumferentialBand03 },
					{ seatType: 'backSeat',  component: 'circumferentialBand03', colorCode: backcircumferentialBand03 }
				];
				
				const validComponents = ["circumferentialBand01", "circumferentialBand02", "circumferentialBand03"];

				// If-Abfrage mit den erweiterten Bedingungen
				if (
					validComponents.includes(component) && // Überprüft, ob 'component' gültig ist
					frontSeatComponentColorCode === frontSeatBasis && // Überprüft, ob der Farbcode des aktuellen Umfangsbands gleich 'frontSeatBasis' ist
					bands
						.filter(band => band.component !== component && band.colorCode !== undefined) // Ignoriere die aktuelle 'component' und undefinierte
						.every(band => band.colorCode === frontSeatBasis ) // Überprüft, ob alle anderen Farbcode-Werte gleich 'frontSeatBasis' sind
				) {
					bands.forEach(band => {
						if (band.colorCode !== undefined) {
							// Aktion 1: Bild auf dem Sitz setzen
							setImageOnSeat(band.seatType, band.component, frontcircumferentialBand);
							//console.log('setImageOnSeat', band.seatType, band.component, frontcircumferentialBand);
							
							// Aktion 2: Auswahlstatus simulieren
							if (band.seatType === 'frontSeat') {
								fakeSelected(`seat-single #${getFrontSeatComponentDotId(band.component)}`, frontcircumferentialBand);
								//console.log('fakeSelected', `seat-single #${getFrontSeatComponentDotId(band.component)}`, frontcircumferentialBand);
							} else if (band.seatType === 'backSeat') {
								fakeSelected(`backseat #${getBackSeatComponentDotId(band.component)}`, frontcircumferentialBand);
								//console.log('fakeSelected', `backseat #${getBackSeatComponentDotId(band.component)}`, frontcircumferentialBand);
							}
						}
					});
				}
			}

			// === Erstklick-Kopplungen Q4Q_AU546 (q7_g8) === START
			if (frontSeatModel === 'Q4Q_AU546') {
				const Q4Q_DEBUG = false; // auf false setzen, sobald alles läuft
				const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
				const newColor = element.querySelector('input')?.value;

				const readColor = (seat, c) => document.querySelector(
					`#seat-components #${c} td[name=${seat === 'frontSeat' ? 'frontseat' : 'backseat'}]`
				)?.getAttribute('color-code');

				// Wichtig: das geklickte Bauteil wurde im allgemeinen Handler oben evtl. schon umgefärbt.
				// Deshalb für die clicked-Komponente den PRE-Klick-Wert nutzen, für die anderen live lesen.
				const triggerOnBasis = (seat, list, clicked, clickedPreColor) => {
					if (clickedPreColor !== mainSeatColorCode) return false;
					return list.filter(c => c !== clicked)
						.every(c => readColor(seat, c) === mainSeatColorCode);
				};

				const applyGroup = (targetSeat, list) => {
					if (Q4Q_DEBUG) console.log('[Q4Q_AU546] applyGroup', targetSeat, list, '→', newColor);
					list.forEach(c => {
						setImageOnSeat(targetSeat, c, newColor);
						const dotId = targetSeat === 'frontSeat'
							? getFrontSeatComponentDotId(c)
							: getBackSeatComponentDotId(c);
						const scope = targetSeat === 'frontSeat' ? 'seat-single' : 'backseat';
						fakeSelected(`${scope} #${dotId}`, newColor);
					});
				};

				// Group A: Front-Klick koppelt vorne, ggf. Spiegelung nach hinten (one-way)
				const frontGroupA = ['headBoxSide','circumferentialBand01','circumferentialBand02','circumferentialBand03'];
				if (seatType === 'frontSeat' && frontGroupA.includes(component)) {
					const onBasis = triggerOnBasis('frontSeat', frontGroupA, component, frontSeatComponentColorCode);
					if (Q4Q_DEBUG) {
						console.log('[Q4Q_AU546] Group A check', {
							frontColors: frontGroupA.map(c => [c, readColor('frontSeat', c)]),
							clickedPreColor: frontSeatComponentColorCode,
							onBasis
						});
					}
					if (onBasis) {
						applyGroup('frontSeat', frontGroupA);
						const backGroupA = backSeatModel === 'N1F_5KA_5KL'
							? ['headrestSideRear','circumferentialBand01','circumferentialBand02','circumferentialBand03']
							: ['headBoxSide','circumferentialBand01','circumferentialBand02','circumferentialBand03'];
						// Wenn das hintere Bauteil namensgleich mit dem geklickten Frontteil ist,
						// hat der allgemeine Handler den Rücksitz möglicherweise schon
						// gespiegelt. In dem Fall den pre-Klick-Wert nutzen.
						const backAllOnBasis = backGroupA.every(c => {
							const value = (c === component) ? backSeatComponentColorCode : readColor('backSeat', c);
							return value === mainSeatColorCode;
						});
						if (Q4Q_DEBUG) {
							console.log('[Q4Q_AU546] Group A back-mirror check', {
								backColors: backGroupA.map(c => [c, readColor('backSeat', c)]),
								backAllOnBasis
							});
						}
						if (backAllOnBasis) {
							applyGroup('backSeat', backGroupA);
						}
					}
				}

				// Group B + C: Back-Klick N1F_5KI (rein hinten)
				if (seatType === 'backSeat' && backSeatModel === 'N1F_5KI') {
					const backGroupB = ['headBoxSide','circumferentialBand01','circumferentialBand02','circumferentialBand03'];
					if (backGroupB.includes(component)) {
						const onBasis = triggerOnBasis('backSeat', backGroupB, component, backSeatComponentColorCode);
						if (Q4Q_DEBUG) console.log('[Q4Q_AU546] Group B check', {
							backColors: backGroupB.map(c => [c, readColor('backSeat', c)]),
							clickedPreColor: backSeatComponentColorCode, onBasis
						});
						if (onBasis) applyGroup('backSeat', backGroupB);
					}
					const backGroupC = ['seatSideBolstersOutside','seatSideBolstersOutside02b','seatSideBolstersOutside04'];
					if (backGroupC.includes(component)) {
						const onBasis = triggerOnBasis('backSeat', backGroupC, component, backSeatComponentColorCode);
						if (Q4Q_DEBUG) console.log('[Q4Q_AU546] Group C check', {
							backColors: backGroupC.map(c => [c, readColor('backSeat', c)]),
							clickedPreColor: backSeatComponentColorCode, onBasis
						});
						if (onBasis) applyGroup('backSeat', backGroupC);
					}
				}

				// Group D: Back-Klick N1F_5KA_5KL (rein hinten)
				if (seatType === 'backSeat' && backSeatModel === 'N1F_5KA_5KL') {
					const backGroupD = ['headrestSideRear','circumferentialBand01','circumferentialBand02','circumferentialBand03'];
					if (backGroupD.includes(component)) {
						const onBasis = triggerOnBasis('backSeat', backGroupD, component, backSeatComponentColorCode);
						if (Q4Q_DEBUG) console.log('[Q4Q_AU546] Group D check', {
							backColors: backGroupD.map(c => [c, readColor('backSeat', c)]),
							clickedPreColor: backSeatComponentColorCode, onBasis
						});
						if (onBasis) applyGroup('backSeat', backGroupD);
					}
				}

				// Group E: Back-Klick N1F_5KA_5KL Kopfstütze Rear + Sitzseitenwange außen oben.
				// Trigger: headrestRear ODER seatSideBolstersOutside02b. Beide Erstklicks
				// koppeln zusätzlich centerHeadrestRear mit. centerHeadrestRear allein ist
				// kein Trigger (kein Reverse-Trigger über die Mitte).
				const backGroupETriggers = ['headrestRear','seatSideBolstersOutside02b'];
				if (seatType === 'backSeat' && backSeatModel === 'N1F_5KA_5KL' && backGroupETriggers.includes(component)) {
					const backGroupE = ['headrestRear','centerHeadrestRear','seatSideBolstersOutside02b'];
					const onBasis = triggerOnBasis('backSeat', backGroupE, component, backSeatComponentColorCode);
					if (Q4Q_DEBUG) console.log('[Q4Q_AU546] Group E check', {
						backColors: backGroupE.map(c => [c, readColor('backSeat', c)]),
						clickedPreColor: backSeatComponentColorCode, onBasis
					});
					if (onBasis) applyGroup('backSeat', backGroupE);
				}

				// Group F: Back-Klick N1F_5KA_5KL Mittelsitz (rein hinten, symmetrisch).
				// Erstklick auf eines der fünf Mittelsitz-Bauteile färbt alle fünf mit.
				// contrastStitchingCenterHeadrest startet ggf. mit einer Stitch-Farbe aus
				// dem vorherigen 'seat'-Screen (z.B. rot) – also nicht auf Leder-Basis.
				// Deshalb wird die Stitch-Komponente vom Basis-Check ausgenommen: nur die
				// 4 Leder-Bauteile müssen noch auf Leder-Basis stehen. Trotzdem wird die
				// Stitch-Komponente beim applyGroup mit der gewählten Farbe gefärbt.
				if (seatType === 'backSeat' && backSeatModel === 'N1F_5KA_5KL') {
					const backGroupF = ['seatCenterSectionAbove','seatCenterSectionBottom','rearCenterArmrest','bolstersCenter','contrastStitchingCenterHeadrest'];
					const backGroupFstitch = 'contrastStitchingCenterHeadrest';
					if (backGroupF.includes(component)) {
						// Wenn der Stitch-Trigger eine Stitch-only-Farbe wählt (z.B.
						// Ozeanblau/Iguanagrün/Leuchtorange), darf die Kopplung nicht
						// feuern – die Lederteile haben diese Farbe nicht und würden
						// fehlerhaft gerendert. Validierung: die gewählte newColor muss
						// als label.colnr-N in der Farbpalette eines Leder-Dots der
						// Gruppe existieren.
						let stitchTriggerInvalid = false;
						if (component === backGroupFstitch) {
							const leatherCheckDotId = getBackSeatComponentDotId('rearCenterArmrest');
							stitchTriggerInvalid = !document.querySelector(
								`#${leatherCheckDotId} label.colnr-${newColor}`
							);
						}
						if (stitchTriggerInvalid) {
							if (Q4Q_DEBUG) console.log('[Q4Q_AU546] Group F skip: Stitch-only color', newColor);
						} else {
							const clickedOnBasis = (component === backGroupFstitch)
								? true
								: backSeatComponentColorCode === mainSeatColorCode;
							const othersOnBasis = backGroupF
								.filter(c => c !== component && c !== backGroupFstitch)
								.every(c => readColor('backSeat', c) === mainSeatColorCode);
							const onBasis = clickedOnBasis && othersOnBasis;
							if (Q4Q_DEBUG) console.log('[Q4Q_AU546] Group F check', {
								backColors: backGroupF.map(c => [c, readColor('backSeat', c)]),
								clickedPreColor: backSeatComponentColorCode, clickedOnBasis, othersOnBasis, onBasis
							});
							if (onBasis) applyGroup('backSeat', backGroupF);
						}
					}
				}

				// 1:1 Same-Color-Mirror: Front headBoxSide → Back headrestSideRear (nur N1F_5KA_5KL).
				// Greift bei jedem Klick auf Front headBoxSide, sofern Front headBoxSide und
				// Back headrestSideRear vor dem Klick dieselbe Farbe hatten. Beim Erstklick auf
				// Basis hat Group A oben den Rücksitz schon gespiegelt – der Live-Read von
				// headrestSideRear liefert dann die NEUE Farbe, die Bedingung schlägt fehl,
				// und der Mirror feuert nicht doppelt.
				if (seatType === 'frontSeat' && component === 'headBoxSide' && backSeatModel === 'N1F_5KA_5KL') {
					const backHeadrestSideRearColor = readColor('backSeat', 'headrestSideRear');
					if (frontSeatComponentColorCode && frontSeatComponentColorCode === backHeadrestSideRearColor) {
						setImageOnSeat('backSeat', 'headrestSideRear', newColor);
						fakeSelected(`backseat #${getBackSeatComponentDotId('headrestSideRear')}`, newColor);
						if (Q4Q_DEBUG) console.log('[Q4Q_AU546] 1:1 mirror headBoxSide → headrestSideRear');
					}
				}
			}
			// === Erstklick-Kopplungen Q4Q_AU546 (q7_g8) === END
		})
	})
}

function getFrontSeatComponentDotId(component) {
	switch (component) {
		case 'headrestSide': return 'headrestSide'
		case 'headrestFront': return 'headrestFront'
		case 'headrestRear': return 'headrestRear'
		case 'headBoxSide': return 'headBoxSide'
		case 'headBoxFront': return 'headBoxFront'
		case 'headrestFrontSline': return 'headrestFrontSline'
		case 'headrestStitching': return 'headrestStitching'
		case 'shoulderArch': return 'shoulderArch'
		case 'shoulderBolsters': return 'shoulderBolsters'
		case 'thighPad': return 'thighPad'
		case 'bolstersOutside': return 'bolstersOutside'
		case 'seatCenterPanel': return 'seatCenterPanel'
		case 'seatSideBolstersInside': return 'seatSideBolstersInside'
		case 'circumferentialBand': return 'circumferentialBand'
		case 'circumferentialBand01': return 'circumferentialBand01'
		case 'circumferentialBand02': return 'circumferentialBand02'
		case 'circumferentialBand03': return 'circumferentialBand03'
		case 'seatSideBolstersOutside': return 'seatSideBolstersOutside'
		case 'seatSideBolstersOutside02': return 'seatSideBolstersOutside02'
		case 'seatSideBolstersOutside03': return 'seatSideBolstersOutside03'
		case 'seatSideBolstersOutside04': return 'seatSideBolstersOutside04'
		case 'seatSideBolstersOutside05': return 'seatSideBolstersOutside05'
		case 'backrestTop': return 'backrestTop'
		case 'contrastStitchingSide': return 'contrastStitchingSide'
		case 'contrastStitchingCenter': return 'contrastStitchingCenter'
		case 'contrastStitchingHoneycombQuilting': return 'contrastStitchingHoneycombQuilting'
		case 'contrastStitchingDiamondQuilting': return 'contrastStitchingDiamondQuilting'
		case 'embossing': return 'embossing'
		case 'biese': return 'biese'
		case 'headrestFront2': return 'headrestFront2'
		case 'seatCenterPanel2': return 'seatCenterPanel2'
		case 'seatSportStripe': return 'seatSportStripe'
		case 'backrestCover': return 'backrestCover'
		case 'seatCover2': return 'seatCover2'
		default:
			break;
	}
}

function getBackSeatComponentDotId(component) {
	switch (component) {
		case 'headrestFront': return 'back-headrestFront'
		case 'headrestSide': return 'back-headrestSide'
		case 'headrestRear': return 'back-headrestRear'
		case 'headBoxSide': return 'back-headBoxSide'
		case 'headBoxFront': return 'back-headBoxFront'
		case 'headrestFrontSline': return 'back-headrestFrontSline'
		case 'headrestSideRear': return 'back-headrestSideRear'
		case 'headrestStitching': return 'back-headrestStitching'
		case 'centerHeadrestFront': return 'back-centerHeadrestFront'
		case 'centerHeadrestSide': return 'back-centerHeadrestSide'
		case 'centerHeadrestRear': return 'back-centerHeadrestRear'
		case 'shoulderArch': return 'back-shoulderArch'
		case 'thighPad': return 'back-thighPad'
		case 'bolstersOutside': return 'back-bolstersOutside'
		case 'bolstersCenter': return 'back-bolstersCenter'
		case 'seatCenterPanel': return 'back-seatCenterPanel'
		case 'seatSideBolstersInside': return 'back-seatSideBolstersInside'
		case 'circumferentialBand': return 'back-circumferentialBand'
		case 'circumferentialBand2': return 'back-circumferentialBand2'
		case 'circumferentialBand01': return 'back-circumferentialBand01'
		case 'circumferentialBand02': return 'back-circumferentialBand02'
		case 'circumferentialBand03': return 'back-circumferentialBand03'
		case 'seatSidePadding': return 'back-seatSidePadding'
		case 'seatSideBolstersOutside': return 'back-seatSideBolstersOutside'
		case 'seatSideBolstersOutside2': return 'back-seatSideBolstersOutside2'
		case 'seatSideBolstersOutside02b': return 'back-seatSideBolstersOutside02b'
		case 'seatSideBolstersOutside04': return 'back-seatSideBolstersOutside04'
		case 'backrestTop': return 'back-backrestTop'
		case 'rearCenterArmrest': return 'back-rearCenterArmrest'
		case 'seatCenterSectionAbove': return 'back-seatCenterSectionAbove'
		case 'seatCenterSectionBottom': return 'back-seatCenterSectionBottom'
		case 'contrastStitchingCenterHeadrest': return 'back-contrastStitchingCenterHeadrest'
		case 'contrastStitchingSide': return 'back-contrastStitchingSide'
		case 'contrastStitchingCenter': return 'back-contrastStitchingCenter'
		case 'contrastStitchingHoneycombQuilting': return 'back-contrastStitchingHoneycombQuilting'
		case 'contrastStitchingDiamondQuilting': return 'back-contrastStitchingDiamondQuilting'
		case 'embossing': return 'back-embossing'
		case 'biese': return 'back-biese'
		case 'headrestFront2': return 'back-headrestFront2'
		case 'seatCenterThighPad': return 'back-seatCenterThighPad'
		case 'seatCenterShoulderArch': return 'back-seatCenterShoulderArch'
		case 'seatCenterBolster': return 'back-seatCenterBolster'
		case 'seatCenterBolsterBottom': return 'back-seatCenterBolsterBottom'
		case 'seatCenterMiddle': return 'back-seatCenterMiddle'
		case 'seatSideBolstersBottom': return 'back-seatSideBolstersBottom'
		case 'seatMiddle': return 'back-seatMiddle'
		case 'seatCenterPanel2': return 'back-seatCenterPanel2'
		case 'seatSportStripe': return 'back-seatSportStripe'
		default:
			break;
	}

}

/**
 * Kopplungen dürfen eine Farbe nur weiterreichen, wenn der Ziel-Dot sie überhaupt anbietet.
 * Beispiel: RS 5 mit FC1 kennt an der mittleren Kopfstütze kein Stahlgrau.
 */
function isColorOfferedOnBackSeatComponent(component, colorCode) {
	const dotId = getBackSeatComponentDotId(component)
	const dot = dotId ? document.querySelector('#' + dotId) : null
	if (!dot) return true
	return !!dot.querySelector('input[value="' + colorCode + '"]')
}

function setImageOnSeat(seatType, component, colorCode) {
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
	const seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value;
	replaceImage(seatType, component, colorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	if (component != 'upholsteryBarOutside') {
		updateTableValue(seatType, component, colorCode)
	}
	const seatJson = createSeatJson(seatType, component, colorCode)
	doAjax(seatJson)

	// special for embossing START
	if(seatType == 'frontSeat') {
		if(component == 'backrestTop') {
			doAjax({
				'frontSeatComponent' : true,
				'frontSeatPressedEmbossingColor': colorCode
			}, (response) => {
			})
			doAjax({
				'frontSeatComponent' : true,
				'embossingPressedColor': colorCode
			}, (response) => {
			})
			doAjax({
				'backSeatComponent' : true,
				'frontSeatPressedEmbossingColor': colorCode
			}, (response) => {
			})
			doAjax({
				'backSeatComponent' : true,
				'embossingPressedColor': colorCode
			}, (response) => {
			})
		}
	}
	// special for embossing END

	// special for pillow START
	if(seatType == 'backSeat') {
		if(component == 'headrestFront') {
			doAjax(createSeatJson('backSeat', 'headrestPillow', colorCode))
		} 
		if(component == 'seatCenterPanel') {
			doAjax(createSeatJson('backSeat', 'extraPillow', colorCode))
			//doAjax(createSeatJson('backSeat', 'audiRingsStiching', colorCode))
		} 
		if(component == 'contrastStitchingCenter') {
			if(colorCode == 9 || colorCode == 10 || colorCode == 11) {
				colorCode = document.querySelector('#seat-components #seatCenterPanel td[name=backseat]')?.getAttribute('color-code')
			}
			doAjax(createSeatJson('backSeat', 'audiRingsStiching', colorCode))
		}
	}
	// special case for pillow END
}

function replaceImage(seatType, component, colorCode, frontSeatModel, backSeatModel, seatComponentSelection) {
	const thirdSeatRow = document.querySelector("input[name=thirdseatrow]").value;
	const q1dembossing = document.querySelector("input[name=q1dembossing]").value;
	const modelcategory = document.querySelector("input[name=modelcategory]").value;
	let thirdRowComponents = ['q7_g8', 'q9_g8'].includes(modelcategory)
		? ['headrestFront','headrestSide','seatCenterPanel','headrestStitching','contrastStitchingSide','contrastStitchingHoneycombQuilting','contrastStitchingDiamondQuilting','contrastStitchingCenter']
		: ['headrestSide', 'headrestFront','contrastStitchingSide','thighPad',
		'bolstersOutside','shoulderArch','seatSideBolstersInside','seatCenterPanel2',
		'seatSportStripe','circumferentialBand'];
	if (seatType == 'backSeat' && thirdSeatRow && thirdRowComponents.includes(component)) {
		replaceImage('thirdSeatRow', component, colorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	}
	// fake select no component in backseat
	if (seatType == 'thirdSeatRow' && frontSeatModel == 'Q4Q_AU53X' && component == 'seatCenterPanel2') {
		replaceImage('thirdSeatRow', 'seatSportStripe', colorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	}
	var element_id = ''
	var element_class = ''
	var seatarrayname = ''
	var carmodel = document.querySelector("input[name=carmodel]").value;
	if (seatType == 'frontSeat') {
		element_id = 'seat-single'
		element_class = '.wrapper-relative img.overlay'
		seatarrayname = 'frontseat_'+frontSeatModel+'_component_path'
	} else if (seatType == 'backSeat') {
		element_id = 'backseat'
		element_class = '.wrapper-relative img.overlay'
		seatarrayname = 'backseat_'+frontSeatModel+'_'+backSeatModel+'_component_path'
	} else { // third seat row
		element_id = 'third-row'
		element_class = '.wrapper-relative-third-row img.overlay'
		seatarrayname = ['q7_g8', 'q9_g8'].includes(modelcategory) ? 'thirdseatrow_q7_g8_component_path' : 'thirdseatrow_q7_component_path'
	}
	if ((document.getElementById(component) || seatType == 'thirdSeatRow') && colorCode != undefined) {
		var componentPictureName = aeo['components']['seat_components_screen'+seatComponentSelection][component] + '.png';
		var slineApplies = q1dembossing && (component == 'backrestTop' || component == 'headrestFront') && modelcategory != 'a8' && seatType != 'thirdSeatRow';
		if (slineApplies && component == 'headrestFront' && seatType == 'backSeat' && backSeatModel.indexOf('5KI') === -1) {
			slineApplies = false; // 5KA_5KL hat keine _s-Variante für headrestFront
		}
		var embossingVariant = aeo['components']['seat_components_screen'+seatComponentSelection+q1dembossing];
		if (slineApplies && (!embossingVariant || embossingVariant[component] === undefined)) {
			slineApplies = false; // z.B. _embossing_rsline hat kein eigenes headrestFront-Bild -> Standardbild verwenden
		}
		if(slineApplies) {
			componentPictureName = aeo['components']['seat_components_screen'+seatComponentSelection+q1dembossing][component] + '.png';
		}


		if(q1dembossing && component == 'shoulderArch' && modelcategory == 'a8') { // only A8
			if (seatType == 'frontSeat') {
				componentPictureName = aeo['components']['seat_components_screen'+seatComponentSelection+q1dembossing+'_A8'][component] + '.png';	
			}
		}
		//const imageSource = aeo['paths'][seatType == 'frontSeat' ? 'frontseat_'+frontSeatModel+'_component_path' : 'backseat_'+frontSeatModel+'_'+backSeatModel+'_component_path'][colorCode] + componentPictureName
		const imageSource = aeo['paths'][seatarrayname][colorCode] + componentPictureName
		
		//let imageArray = document.getElementById(seatType == 'frontSeat' ? 'seat-single' : 'backseat').querySelectorAll('.wrapper-relative img.overlay')
		let imageArray = document.getElementById(element_id).querySelectorAll(element_class)
		const imageId = component + '-img'
		let imageExists = false;
		imageArray.forEach(element => {
			if (element.id != null && element.id == imageId) {
				imageExists = true
				element.src = imageSource
			}
		});
		if (!imageExists && imageArray.length > 0) {
			let newImage = document.createElement('IMG')
			newImage.classList.add('overlay')
			newImage.id = component + '-img'
			imageArray[imageArray.length - 1].insertAdjacentElement('afterend', newImage)
			newImage.src = imageSource
		}
	}
	
}

function updateTableValue(seatType, component, colorCode) {
	let query = '#seat-components #' + component + ' td[name=\"' + (seatType == 'frontSeat' ? 'frontseat' : 'backseat') + '\"]'
	let valueOnTable = document.querySelector(query)
	valueOnTable.setAttribute('color-code', colorCode)
	valueOnTable.innerHTML = getColorByCode(colorCode)
}


function createSeatJson(seatType, component, colorCode) {
	const json = {};
	json[seatType + 'Component'] = true
	json[component + 'PressedColor'] = colorCode
	return json;
}


function loadBasicColorSeatLayers(frontSeatModel,backSeatModel) {
	const seatColorCode = document.querySelector('#picked-color td[color-code]')?.getAttribute('color-code').toString()
	const stitchSeatColorCode = document.querySelector('#picked-stitch td[color-code]')?.getAttribute('color-code').toString()
	const q1dembossing = document.querySelector("input[name=q1dembossing]").value;
	const seatTypes = ["frontSeat", "backSeat"]
	seatTypes.forEach(seatType => {
		var carmodel = document.querySelector("input[name=carmodel]").value;
		if ((carmodel == 2) || (carmodel == 200)) {
			var seatColorSrc = aeo['images'][seatType == "frontSeat" ? 'frontseat_RS_'+frontSeatModel+'_color' : 'backseat_'+frontSeatModel+'_'+backSeatModel+'_color'][seatColorCode]
		} else if (carmodel == 1) {
			var seatColorSrc = aeo['images'][seatType == "frontSeat" ? 'frontseat_S_'+frontSeatModel+'_color' : 'backseat_'+frontSeatModel+'_'+backSeatModel+'_color'][seatColorCode]
		} else {
			var seatColorSrc = aeo['images'][seatType == "frontSeat" ? 'frontseat_'+frontSeatModel+'_color' : 'backseat_'+frontSeatModel+'_'+backSeatModel+'_color'][seatColorCode]
		}
		const stitchColorSrc = aeo['images'][seatType == "frontSeat" ? 'frontseat_'+frontSeatModel+'_stitch_color' : 'backseat_'+frontSeatModel+'_'+backSeatModel+'_stitch_color'][stitchSeatColorCode]
		var embossingColorSrc = "/img/03_sitze/front_empty.png"
		if(q1dembossing && seatType == "frontSeat") {
			embossingColorSrc = aeo['images']['frontseat_'+frontSeatModel+q1dembossing+'_color'][seatColorCode]
		}
		if(q1dembossing == '_embossing_rsline' && seatType == "backSeat") {
			embossingColorSrc = aeo['images']['backseat_'+frontSeatModel+q1dembossing+'_color'][seatColorCode]
		}
		const imgSources = [embossingColorSrc, seatColorSrc, stitchColorSrc]
		imgSources.forEach(imageSource => {
			const query = '#' + (seatType == 'frontSeat' ? 'seat-single' : 'backseat') + ' img[alt="seat-base"]'
			let baseImage = document.querySelector(query)
			let newImage = document.createElement('IMG')
			newImage.classList.add('overlay')
			newImage.id = seatType + 'basis-img'
			baseImage.insertAdjacentElement('afterend', newImage)
			newImage.src = imageSource
		})
	})
}

/** Loads already customized components */
function checkCustomizedComponentsOnLoading(seatType, component) {

	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
	const seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value;
	const seatTypeNameValue = seatType == "frontSeat" ? "frontseat" : "backseat"
	let query = `#seat-components #${component} td[name="${seatTypeNameValue}"]`
	if (component == 'upholsteryBarOutside') {
		query = `#seat-components #seatCenterPanel td[name="${seatTypeNameValue}"]`
	}
	let componentColorCode = document.querySelector(query)?.getAttribute('color-code')
	replaceImage(seatType, component, componentColorCode, frontSeatModel, backSeatModel, seatComponentSelection)
}

export { initComponentsSeatsCustomizing, loadBasicColorSeatLayers };